import AppButton from '../../../../components/atoms/AppButton/AppButton'
import Layout from '../../../../layout/Layout'
import HeaderPageSection from '../../../../components/molecules/HeaderPageSection/HeaderPageSection'
import UserList from '../organisms/UserList'
import { useLocation, useNavigate } from 'react-router-dom'
import Pagination from '../../../../components/molecules/Pagination/Pagination'
import { Box } from '../../../../components/atoms/AppBox'
import SearchInput from '../../../../components/molecules/SearchInput/SearchInput'
import useUsers from '../../hooks/useUsers'
import useDeleteUser from '../../hooks/useUserDelete'
import { useEffect, useRef, useState } from 'react'
import { CustomTabs } from 'components/atoms/AppTabs/AppTabs'
import { Snackbar } from 'components/atoms/Snackbar/Snackbar'

const tabs = [
    { id: 'all', label: 'Todos' },
    { id: '1', label: 'Administrador' },
    { id: '2', label: 'Operarios' },
]
interface SnackbarHandle {
    showModal: (value: boolean) => void
}

export default function UserPage() {
    const navigate = useNavigate()
    const [searchValue, setSearchValue] = useState('')
    const snackbarRef = useRef<SnackbarHandle>(null)
    const [activeTab, setActiveTab] = useState('all')
    const [currentPage, setCurrentPage] = useState(1)
    const [snackbarMessage, setSnackbarMessage] = useState<{
        title: string
        description: string
        state: 'success' | 'error'
    }>({
        title: 'Éxito',
        description: 'Acción completada',
        state: 'success',
    })

    // Construir filtros para enviar al servidor
    const filters = {
        name: searchValue.length >= 3 ? searchValue : undefined,
        role_id: activeTab !== 'all' ? parseInt(activeTab) : undefined,
        page: currentPage,
    }
    const location = useLocation()
    const state = location.state
    const { users, pagination, refreshUsers, loading } = useUsers(filters)
    const { deleteUser } = useDeleteUser()

    const handleTabChange = (tabId: string) => {
        setActiveTab(tabId)
        setCurrentPage(1) // Reset a página 1 al cambiar filtros
    }

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value)
        setCurrentPage(1) // Reset a página 1 al cambiar búsqueda
    }

    const changePage = (page: number) => {
        setCurrentPage(page)
    }

    useEffect(() => {
        if (
            snackbarRef.current !== null &&
            state !== null &&
            state.title !== undefined &&
            state.description !== undefined
        ) {
            setSnackbarMessage({
                title: state.title,
                description: state.description,
                state: state.state,
            })
            snackbarRef.current.showModal(true)
        }
    }, [state])

    const handleDeleteUser = async (userId: number) => {
        const DeleteUser = await deleteUser(userId)
        if (DeleteUser) {
            if (snackbarRef.current !== null) {
                setSnackbarMessage({
                    title: '¡Éxito!',
                    description: 'Usuario eliminado correctamente',
                    state: 'success',
                })
                snackbarRef.current.showModal(true)
            }
        }
        await refreshUsers()
    }

    return (
        <Layout>
            <HeaderPageSection title="Usuarios" showGoBack={false}>
                <div>
                    <AppButton
                        title="Nuevo Usuario"
                        style={{
                            backgroundColor: '#568C13',
                            marginBottom: '1rem',
                        }}
                        onClick={() => navigate('/users/create')}
                    />
                </div>
            </HeaderPageSection>
            <Box>
                <div>
                    <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between mb-6">
                        <CustomTabs
                            tabs={tabs}
                            activeTab={activeTab}
                            onTabChange={handleTabChange}
                        />
                        <SearchInput
                            value={searchValue}
                            onChange={handleSearchChange}
                            placeholder="Buscar por nombre o email..."
                        />
                    </div>
                </div>
                {loading ? (
                    <div className="text-center py-8">Cargando usuarios...</div>
                ) : (
                    <>
                        <UserList list={users} onDelete={handleDeleteUser} />
                        <div className="mt-10 flex justify-center">
                            <Pagination
                                totalPages={Math.ceil(
                                    pagination.totalItems /
                                        pagination.itemsPerPage
                                )}
                                currentPage={pagination.page}
                                onPageChange={changePage}
                            />
                        </div>
                    </>
                )}
            </Box>
            <Snackbar
                ref={snackbarRef}
                title={snackbarMessage.title}
                description={snackbarMessage.description}
                state={snackbarMessage.state}
                closeAction
                time={2000}
            />
        </Layout>
    )
}
